import { useRef, useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';

import AuthContext from '../../../api/AuthProvider';

const LoginForm = () => {
    const { loginUser } = useContext(AuthContext);
    const userRef = useRef();
    const errRef = useRef();

    const [user, setUser] = useState('');
    const [pwd, setPwd] = useState('');
    const [errMsg, setErrMsg] = useState('');

    useEffect(() => {
        userRef.current.focus();
    }, []);

    useEffect(() => {
        setErrMsg('');
    }, [user, pwd]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const requestBody = {
            username: e.target.username.value,
            password: e.target.password.value,
        };

        loginUser(requestBody).catch((err) => {
            if (!err?.response) {
                setErrMsg('No Server Response');
            } else if (err.response?.status === 401) {
                setErrMsg(
                    'Unauthorized. Please check your username and password.'
                );
            } else {
                setErrMsg('Login Failed');
            }
            errRef.current.focus();
        });
    };

    return (
        <>
            <section>
                <h1>Login</h1>
                <form onSubmit={handleSubmit}>
                    <div className="form-group mb-4">
                        <label htmlFor="username" className="mb-0">
                            Username
                        </label>
                        <input
                            className="form-control"
                            type="text"
                            id="username"
                            placeholder="Username"
                            ref={userRef}
                            autoComplete="off"
                            onChange={(e) => setUser(e.target.value)}
                            value={user}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password" className="mb-0">
                            Password
                        </label>
                        <input
                            className="form-control"
                            type="password"
                            id="password"
                            placeholder="Password"
                            onChange={(e) => setPwd(e.target.value)}
                            value={pwd}
                            required
                        />
                    </div>
                    <div className="submit-button">
                        <button type="submit" className="btn button-secondary">
                            Sign In
                        </button>
                    </div>
                    <p>
                        Need access? <Link to="/register">Request Access</Link>
                    </p>
                </form>
                <p
                    ref={errRef}
                    className={errMsg ? 'errmsg' : 'offscreen'}
                    aria-live="assertive"
                >
                    {errMsg}
                </p>
            </section>
        </>
    );
};

export default LoginForm;
